import { render } from "./salary-domiciliation.vue?vue&type=template&id=83117594"
import script from "./salary-domiciliation.vue?vue&type=script&lang=js"
export * from "./salary-domiciliation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__